<div class="w-full h-full rounded-1.5 overflow-hidden gradient-border">
	<div class="rounded-1.5 w-full h-full bg-280 flex flex-col items-start justify-start">
		<div class="p-1 flex-none gap-0.5 w-full flex items-center justify-start">
			<div buttonIcon size="S" class="invisible" [disabled]="true">
				<i class="icon-cross-close"></i>
			</div>

			<div class="flex-auto gap-2 overflow-hidden flex items-center justify-center">
				<p class="truncate fc-500">Translate to:</p>

				<button 
					#anchor 
					buttonBasic 
					(click)="menu?.open()" 
					class="bg-190 py-0.75! pr-1! pl-2!" 

				>
					<span class="flex flex-col items-start justify-start">
						@for (item of $languages(); track item.key) {
							<span class="truncate h-0 max-w-full invisible">
								{{ item.value }}
							</span>
						}
						<span class="truncate max-w-full fc-500">{{
							$selectedLanguage().value
						}}</span>
					</span>
					<i class="icon-chevron chevron-down text-icon-s"></i>
				</button>
			</div>

			<button buttonIcon size="S" (click)="close()">
				<i class="icon-cross-close"></i>
			</button>
		</div>
		<div class="relative w-full flex-auto flex flex-col top-gradient scrollbar-fade overflow-auto">
			<div class="py-2 px-3 flex-auto w-full flex items-start justify-start scrollbar-fade overflow-auto">
				<p class="w-full whitespace-pre-line" [class.text-right]="$showRightToLeft()" [class.[direction:rtl]]="$showRightToLeft()" [class.[unicode-bidi:bidi-override]]="$showRightToLeft()">
					@if ($translatedValue().loading) {
						<span
							class="pr-1 inline-flex items-center justify-start h-[calc(1em_*_var(--font-line-height))]"

						>
							<loader-three-dots></loader-three-dots>
						</span>
						Translating...
					} @else if ($translatedValue().failed) {
						There was an error translating.
					} @else {
						{{ $translatedValue().value }}
					}
				</p>
			</div>
		</div>
	</div>
</div>

<client-reach-menu #menu [activeSection]="'1'" (closed)="onMenuClosed()">
	<ng-container *clientReachMenuSection="'1'; anchor: anchor; let isMobile = isMobile">
		<div
			ngProjectAs="[~title]"
			class="py-1 px-1.5 border border-line-250 rounded-1 gap-1.5 w-full bg-270 flex items-center justify-start reach-input-widget-wrapper"
		>
			<i class="icon-search text-icon-s fc-400"></i>
			<input
				type="search"
				class="w-full input-widget"
				placeholder="Search language"
				[(ngModel)]="$query"
			/>
		</div>

		<div ngProjectAs="[~right]">
			<button buttonIcon (click)="menu?.close()">
				<i class="icon-cross"></i>
			</button>
		</div>

		<div class="gap-0.25 w-full h-full flex relative flex-col items-start justify-start scrollbar-fade overflow-auto">
			@if (!isMobile) {
				<div class="p-1 top-0 w-full bg-180 z-1 sticky">
					<div
						class="py-1 px-1.5 border border-line-250 rounded-1 gap-1.5 w-full bg-270 flex items-center justify-start reach-input-widget-wrapper"
					>
						<i class="icon-search text-icon-s fc-400"></i>
						<input
							type="search"
							class="w-full input-widget"
							placeholder="Search language"
							[(ngModel)]="$query"
							autofocusOnInit
						/>
					</div>
				</div>
			}

			@for (item of $languages(); track item.key) {
				<div class="px-1 w-full">
					<button
						buttonBasic
						class="gap-0.25 w-full group/translator"
						(click)="selectLanguage(item.key); menu?.close()"
					>
						<span
							class="flex-auto truncate group-hover/translator:fc-800"
							[class.fc-800]="item.selected"
							[class.fc-500]="!item.selected"
							>{{ item.value }}</span
						>
						<i
							class="flex-none text-l text-primary"
							[class.invisible]="!item.selected"
							[class.icon-tick-black]="item.selected"
						></i>
					</button>
				</div>
			}
		</div>
	</ng-container>
</client-reach-menu>
